/// <reference path='../_all.ts' />

module part {
  'use strict';


  export class PartDetailDTO {
    constructor(
      public HasErsatz: boolean,
      public Part: Part,
      public IsErsatzInFuture: boolean,
      public PictureUrl: string,
      public Image: shoppinglist.Image,
      public ImageFull: shoppinglist.Image,
      public RelatedProducts: ProductRelation[],
      public ProductUrlBase : string,
      public ShowAvailability: boolean,
      public ShowStatus: boolean, //deprecated
      public PartAvailabilityText: string,
      public Status: string, //deprecated
      public ShowPrice: boolean,
      public PriceList: Price[],
      public ErsatzList: any[],
      public PartLinkFormat: any,
      public PartUrl: string,
      public PartAvailabilityCode: number,      
      public CustomsTariffNo : string,
      public CountryOfOrigin : string,
      public NetWeight : number,
    ) { }
  }

}